const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})/;

/**
 * Parses a date-only string as a local calendar date.
 *
 * `new Date('YYYY-MM-DD')` is UTC midnight, which shifts the day west of UTC.
 * A timestamp falls through to `new Date` so a picker value keeps its local day.
 */
export const parseCalendarDate = (value?: string | null): Date | undefined => {
  if (!value) {
    return undefined;
  }

  const match = DATE_ONLY.exec(value);
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
};

/**
 * Formats a picker-selected calendar date for APIs that accept date-only fields.
 *
 * Example: a Madrid user selects 2026-05-13, which JS stores as
 * 2026-05-12T22:00:00.000Z. The API still needs "2026-05-13".
 */
export const formatCalendarDate = (date?: Date | null): string | undefined => {
  if (!date) {
    return undefined;
  }

  const d = new Date(date);
  if (Number.isNaN(d.getTime())) {
    return undefined;
  }

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};
